import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {InfinityScrollProps} from './InfinityScrollProps.interface';

export function InfinityScroll({
  canLoadNextPage,
  requestNextPageData,
  isLoading,
  children,
}: InfinityScrollProps) {
  const {ref, inView} = useInView();

  useEffect(() => {
    if (!isLoading && inView && canLoadNextPage) {
      requestNextPageData();
    }
  }, [canLoadNextPage, requestNextPageData, inView, isLoading]);

  return (
    <>
      {children}
      {/* XXX: (@harry) 높이 0px일 때 intersection observer가 특정 상황에서 잘 동작하지 않는 거 같아 1px 추가합니다. */}
      {!isLoading && <div ref={ref} className="h-1pxr" />}
    </>
  );
}
